import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AppLayout from '../AppLayout';
import { storeMarketplace, updateMarketplace, getMarketplace } from '../../Api';

class MarketplaceForm extends Component {
  state = {
    name: "",
    active: true,
  };

  async componentDidMount() {
    if (this.props.match && this.props.match.params && this.props.match.params.id) {
      const { id } = this.props.match.params;
      const { name, active } = await getMarketplace(id, this.props.usuario.token)
      this.setState({ name, active, _id: id })
    }
  }

  handleSubmit = async event => {
    event.preventDefault();
    if (this.state._id) {
      await this.update({
        _id: this.state._id,
        name: this.state.name,
        active: this.state.active,
      })
    } else {
      await this.store({
        name: this.state.name,
        active: this.state.active
      })
    }
  };

  async store(marketplace) {
    try {
      const res = await storeMarketplace(marketplace, this.props.usuario.token);
      if (res._id) {
        this.props.history.push('/marketplaces');
      } else {
        alert(JSON.stringify(res))
      }
    } catch (error) {
      console.log(error)
    }
  }

  async update(data) {
    try {
      const res = await updateMarketplace(data, this.props.usuario.token);
      if (res._id) {
        this.props.history.push('/marketplaces');
      } else if (res.error) {
        const { message } = res.error;
        alert(message);
      } else {
        alert(JSON.stringify(res))
      }
    } catch (error) {
      console.log(error)
    }
  }

  onInputChange = event => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const id = target.id;
    this.setState({ [id]: value });
    document.getElementById(id).classList.remove("is-danger");
  };

  render() {
    return (
      <AppLayout>
        <h1>Plaza</h1>
        <form className='form'>
          <div className='form-group'>
            <label htmlFor="name">Nombre</label>
            <input className="form-control" type="text" id='name' placeholder="Nombre"
              value={this.state.name} onChange={this.onInputChange} />
          </div>
          <div className='form-group'>
            <div className='checkbox'>
              <label className="">
                <input disabled={this.props.readOnly}
                  className="checkbox" type="checkbox" id='active'
                  checked={this.state.active} onChange={this.onInputChange} />
                Activo
              </label>
            </div>
          </div>
          <button type="submit" className="btn btn-primary" onClick={this.handleSubmit}>Guardar</button>
        </form>
      </AppLayout>
    );
  }
}

const mapStoreToProps = (state, props) => {
  return { ...props, usuario: state.usuario }
}
export default withRouter(connect(mapStoreToProps)(MarketplaceForm));